"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _iconBase = _interopRequireDefault(require("../icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdpPaginationFirst = function AdpPaginationFirst(props) {
  return _react.default.createElement(_iconBase.default, props, _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M1024 516.416c0 281.6-230.4 512-512 512s-512-230.4-512-512 230.4-512 512-512 512 230.4 512 512zm-230.4-245.76c0-5.12 0-10.24-5.12-15.36l-25.6-25.6c-5.12-5.12-10.24-5.12-15.36-5.12s-10.24 0-15.36 5.12l-281.6 271.36c-5.12 5.12-5.12 10.24-5.12 15.36s0 10.24 5.12 15.36l276.48 276.48c5.12 5.12 10.24 5.12 15.36 5.12s10.24 0 15.36-5.12l30.72-30.72c5.12-5.12 5.12-10.24 5.12-15.36s0-10.24-5.12-15.36l-230.4-230.4 230.4-230.4c5.12-5.12 5.12-10.24 5.12-15.36zm-486.4 547.84h30.72c15.36 0 25.6-10.24 25.6-25.6v-542.72c0-15.36-10.24-25.6-25.6-25.6H307.2c-15.36 0-25.6 10.24-25.6 25.6v537.6c-5.12 15.36 10.24 30.72 25.6 30.72z"
  })));
};

AdpPaginationFirst.defaultProps = {
  viewBox: '0 0 1024 1043.776',
  height: '1em',
  width: '0.9811em'
};
AdpPaginationFirst.displayName = 'AdpPaginationFirst';
var _default = AdpPaginationFirst;
exports.default = _default;